<template>
  <div class="sm:py-2 mb-20">
    <div class="sm:hidden empty:hidden">
      <div class="border-solid border-t border-gray-800" />
      <div class="p-2">
        <MenuButton icon="fa-home" :label="$t('menu.home')" url="/" :active="'home'" />
      </div>
      <div class="border-solid border-t border-gray-800" />
    </div>
    <template v-if="isReseller">
      <div class="p-2">
        <MenuButton icon="fa-shopping-basket" :label="$t('menu.createQuote')" url="/new-quote" :active="'designer'" />
        <MenuButton icon="fa-calculator" :label="$t('menu.createOrder')" url="/new-order" :active="'designer'" />
      </div>
    </template>
    <template v-if="isDesigner || isReseller">
      <div class="border-solid border-t border-gray-800 my-2" />
      <div class="p-2">
        <router-link v-if="isDesigner" to="/enquiries">
          <div
            class="flex items-center hover:bg-blue-700"
            :class="{ 'bg-blue-700': $route.meta.active === 'enquiries' }"
          >
            <div class="p-1">
              <div class="rounded-full h-5 w-5 border-solid border-2 border-yellow-500 mr-4" />
            </div>
            <span class="text-white">{{ $t('menu.viewEnquiries') }}</span>
          </div>
        </router-link>
        <router-link v-if="isReseller" to="/quotes">
          <div class="flex items-center hover:bg-blue-700" :class="{ 'bg-blue-700': $route.meta.active === 'quotes' }">
            <div class="p-1">
              <div class="rounded-full h-5 w-5 border-solid border-2 border-orange-500 mr-4" />
            </div>
            <span class="text-white">{{ $t('menu.viewQuotes') }}</span>
          </div>
        </router-link>
        <router-link v-if="isReseller" to="/orders">
          <div class="flex items-center hover:bg-blue-700" :class="{ 'bg-blue-700': $route.meta.active === 'orders' }">
            <div class="p-1">
              <div class="rounded-full h-5 w-5 border-solid border-2 border-green-500 mr-4" />
            </div>
            <span class="text-white">{{ $t('menu.viewOrders') }}</span>
          </div>
        </router-link>
      </div>
    </template>
    <template v-if="authStore.admin">
      <div class="border-solid border-t border-gray-800 my-2" />
      <div class="p-2 group text-white">
        <div
          class="flex items-center cursor-pointer z-50"
          :class="{ 'bg-blue-700': $route.meta.root === 'setup' }"
          @click.stop="isSetup = !isSetup"
        >
          <div class="p-1 mr-4">
            <i class="fal fa-fw fa-sharp fa-light fa-sitemap" />
          </div>
          <div class="flex flex-col justify-around">{{ $t('menu.setup.text') }}</div>
          <div class="ml-auto pr-3 text-xs text-gray-600">
            <i v-if="isSetup" class="fal fa-chevron-up" />
            <i v-else class="fal fa-chevron-down" />
          </div>
        </div>
        <div class="relative overflow-hidden">
          <div v-if="isSetup" class="p-2">
            <ul class="flex flex-col gap-1">
              <li>
                <MenuButton icon="fa-user" :label="$t('menu.setup.account')" :url="'/setup/account'" active="account" />
              </li>
              <li>
                <MenuButton
                  icon="fa-sharp fa-light fa-user-helmet-safety"
                  :label="$t('menu.setup.staff')"
                  :url="'/setup/staff'"
                  active="staff"
                />
              </li>
              <li
                v-if="
                  (isDesigner && authStore.isExtruderOrExpress) ||
                  (!authStore.isExtruderOrExpress && authStore.superuser)
                "
              >
                <MenuButton
                  icon="fa-box"
                  :label="$t('menu.setup.productSettings')"
                  :url="'/setup/product-settings'"
                  active="product-settings"
                />
              </li>
              <li v-if="isReseller && authStore.isExtruderOrExpress">
                <MenuButton
                  icon="fa-table"
                  :label="$t('menu.setup.costsPrices')"
                  :url="'/setup/costs-prices'"
                  active="costs-prices"
                />
              </li>
              <li v-if="isReseller">
                <MenuButton
                  icon="fa-paint-brush"
                  :label="$t('menu.setup.styling')"
                  :url="'/setup/styling'"
                  active="styling"
                />
              </li>
              <li
                v-if="
                  (isDesigner && authStore.isExtruderOrExpress) ||
                  (customerStore.isBrandedModeEnabled && !authStore.isExtruderOrExpress)
                "
              >
                <MenuButton
                  icon="fa-desktop"
                  :label="$t('menu.setup.brandedMode.text', { brandedMode: 'Lead Capture' })"
                  :url="'/setup/lead-capture'"
                  active="lead-capture"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>
    <template v-if="isBase">
      <div class="border-solid border-t border-gray-800 my-2"></div>
      <div class="p-2">
        <MenuButton icon="fa-book-open" :label="$t('menu.resourceCentre')" url="/marketing" :active="'marketing'" />
        <button v-if="styleStore?.fabricator?.name === 'Selecta Systems Ltd'" class="w-full" @click="web2print">
          <div
            class="flex items-center hover:bg-blue-700"
            :class="{ 'bg-blue-700': $route.meta.active === 'lead-capture-mode' }"
          >
            <div class="p-1 mr-4">
              <i class="fa-light fa fa-fw fa-print text-white" />
            </div>
            <span class="text-white mr-2">Web2Print</span>
            <span class="text-white bg-purple-500 py-0.5 px-1 rounded-sm text-xs">New</span>
          </div>
        </button>
        <MenuButton icon="fa-megaphone" :label="$t('menu.news')" url="/news" :active="'news'" />
      </div>
    </template>

    <template v-if="!authStore.isExtruderOrExpress">
      <div class="border-solid border-t border-gray-800 my-2" />
      <div class="p-2">
        <MenuButton
          icon="fa-store"
          :label="$t('menu.store', { touch: 'QUOTILA' })"
          url="/touch-store"
          :active="'touch-store'"
        />
        <MenuButton
          v-if="false"
          icon="fa-square-question"
          :label="$t('menu.knowledgeBase')"
          :external_link="true"
          url="https://bmgroupholdingslimited.freshdesk.com/support/solutions/101000252285"
          :active="''"
        />
        <MenuButton icon="fa-window" :label="$t('menu.support')" url="?hideIntroPopUp=true" :active="''" />
      </div>
    </template>
    <SupportPopUp :company-name="authStore.companyName" />
    <div class="border-solid border-t border-gray-800 my-2" />
    <div class="p-2">
      <LocalesDropdown class="text-white w-full pr-3" bg-class="bg-blue-900" bg-hover-class="hover:bg-blue-700" />
    </div>
  </div>
</template>

<script>
import MenuButton from '@/components/shared/nav/MenuButton.vue'
import SupportPopUp from '@/components/shared/nav/SupportPopUp.vue'
import { useAuthorisation } from '@/composables/authorisation'
import LocalesDropdown from '@/features/locales/components/LocalesDropdown.vue'
import { useAuthStore } from '@/pinia/auth'
import { useCustomerStore } from '@/pinia/customer'
import { useKnowledgeBaseStore } from '@/pinia/knowledge-base'
import { useStyleStore } from '@/pinia/style'
import { config } from '@/utils/config'
import { mapStores } from 'pinia'

export default {
  name: 'PortalMenuItems',
  components: {
    MenuButton,
    SupportPopUp,
    LocalesDropdown
  },
  methods: {
    async web2print() {
      await this.knowledgeBaseStore.generateLinkWeb2Print({
        store_url: config?.store_url,
        api_url: config?.api_url
      })
    }
  },
  props: {
    initialSetup: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const { isBase, isDesigner, isReseller } = useAuthorisation()
    return { isBase, isDesigner, isReseller }
  },
  data() {
    return {
      isSetup: false
    }
  },
  computed: {
    ...mapStores(useAuthStore, useKnowledgeBaseStore, useStyleStore, useCustomerStore)
  },
  created() {
    this.isSetup = this.initialSetup
  }
}
</script>
